import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, perfis, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);

  if (loading) {
    return <BackdropLoading />;
  }

  if (!isAuth && isPrivate) {
    return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
  }

  if (isAuth && !isPrivate) {
    return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
  }

  // Tela restrita a alguns perfis (ex.: Conexoes so para admin). Enquanto o
  // usuario ainda nao carregou (sem profile), deixa passar para nao piscar.
  if (isAuth && perfis && user?.profile && !perfis.includes(user.profile)) {
    return <Redirect to={{ pathname: "/" }} />;
  }

  return <RouterRoute {...rest} component={Component} />;
};

export default Route;
